import { createAction } from 'redux-starter-kit';
import api from '../../api';
import buildStdDbModelActions from './std-db-model-actions';

const stdActions = buildStdDbModelActions('queries');

// Custom transition action: POST /queries/<id>/transition/  body: {to_status, comment}
const transitionSuccess = createAction('queries/transition_success');

const transition = (id, toStatus, comment = '') => async (dispatch) => {
  const res = await api.requestData(`queries/${id}/transition`, undefined, 'post', {}, {
    to_status: toStatus,
    comment,
  });
  dispatch(stdActions.patchSuccess(res));
  dispatch(transitionSuccess(res));
  return res;
};

export default {
  ...stdActions,
  transitionSuccess,
  transition,
};
